import React from 'react';
import LegalLayout, { L } from './LegalLayout';
import { OPERATOR, SUBPROCESSORS } from '../../legal/operator';

export default function SubprocessorsPage() {
  return (
    <LegalLayout title="Subprocessors">
      <L.P>
        {OPERATOR.productName} relies on the third-party service providers listed below to operate
        the Service. We share only the personal data strictly necessary for each provider to perform
        the named function. Transfers outside the EEA are covered by Standard Contractual Clauses or
        equivalent safeguards.
      </L.P>

      <div style={tableWrap}>
        <table style={tableStyle}>
          <thead>
            <tr>
              <th style={thStyle}>Provider</th>
              <th style={thStyle}>Purpose</th>
              <th style={thStyle}>Region</th>
              <th style={thStyle}>Privacy notice</th>
            </tr>
          </thead>
          <tbody>
            {SUBPROCESSORS.map((s) => (
              <tr key={s.name}>
                <td style={tdStyle}><strong>{s.name}</strong></td>
                <td style={tdStyle}>{s.purpose}</td>
                <td style={tdStyle}>{s.region}</td>
                <td style={tdStyle}><L.A href={s.url}>view</L.A></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <L.H2>Notifying you of changes</L.H2>
      <L.P>
        If we add, remove or replace a subprocessor, this page will be updated. Material changes
        will be announced by email or in-app banner. Continued use of the Service after such notice
        constitutes acceptance of the change.
      </L.P>

      <L.H2>Contact</L.H2>
      <L.P>
        Concerns about a specific subprocessor? Write to <L.Mail to={OPERATOR.supportEmail} />.
      </L.P>
    </LegalLayout>
  );
}

const tableWrap = { overflowX: 'auto', margin: '8px 0 16px' };
const tableStyle = { width: '100%', borderCollapse: 'collapse', fontSize: '14px' };
const thStyle = { textAlign: 'left', padding: '10px 12px', borderBottom: '1px solid var(--border)', color: 'var(--text-secondary)', fontWeight: 700, fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.4px' };
const tdStyle = { padding: '10px 12px', borderBottom: '1px solid var(--border)', verticalAlign: 'top' };
